"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initMergeLogic = initMergeLogic;
exports.mergeLogic = mergeLogic; // We do no longer use redux-logic
// This file exists only to support a few existing projects
// We should plan top migrate all projects to only use redux-saga

var logicMiddlewareInstance;
var logicToMerge = [];

function initMergeLogic(logicMiddleware) {
  logicMiddlewareInstance = logicMiddleware;
  merge();
}

function mergeLogic(logic) {
  if (logic) {
    logicToMerge.push(logic);
    merge();
  }
}

function merge() {
  if (!logicMiddlewareInstance) {
    return;
  }

  if (logicToMerge.length) {
    logicMiddlewareInstance.mergeNewLogic(logicToMerge);
    logicToMerge = [];
  }
}